module.exports = __webpack_public_path__ + "components/page-footer/static/surf-forecast__logo--white-c195d0f16bcf7a8e57c40a19e4ff83e7.png";